import { baseApi } from 'shared/api/base-api';
import { GetTournamentAnalyticsArgs, TournamentAnalyticsPayload } from 'modules/analytics/domain/interfaces/tournament-analytics';

const getTournamentAnalyticsQuery = `#graphql
query getTournamentAnalytics($tournamentId: Int!, $championshipId: Int, $startDate: String!, $endDate: String!) {
  tournamentAnalytics(input: {
    tournamentId: $tournamentId,
    championshipId: $championshipId,
    startDate: $startDate,
    endDate: $endDate
  }) {
    summary {
      championshipsCount
      matchesCount
      playedMatchesCount
      uniqueTeamsCount
      totalGoals
      averageGoalsPerMatch
      gameDaysCount
    }
    records {
      mostProductiveMatch {
        matchId
        matchDate
        championshipId
        championshipName
        team1 { id name score emblemUrl }
        team2 { id name score emblemUrl }
        highlightValue
      }
      biggestWin {
        matchId
        matchDate
        championshipId
        championshipName
        team1 { id name score emblemUrl }
        team2 { id name score emblemUrl }
        highlightValue
      }
      fastestGoal {
        matchId
        matchDate
        championshipId
        championshipName
        playerName
        goalSecond
      }
    }
  }
}
`;

interface TournamentAnalyticsResponseDto {
  tournamentAnalytics: TournamentAnalyticsPayload;
}

const analyticsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTournamentAnalytics: build.query<TournamentAnalyticsPayload, GetTournamentAnalyticsArgs>({
      query: ({ tournamentId, championshipId, startDate, endDate }) => ({
        query: getTournamentAnalyticsQuery,
        variables: { tournamentId, championshipId: championshipId ?? undefined, startDate, endDate },
      }),
      transformResponse: (raw: TournamentAnalyticsResponseDto): TournamentAnalyticsPayload => {
        return raw.tournamentAnalytics;
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetTournamentAnalyticsQuery } = analyticsApi;
